import { AxiosInterceptor } from "api/core/consts";

export const kpi = {
  searchKpiUnit: (body) => AxiosInterceptor.post('kpiUnit/company', body),
  searchKpiData: (body) => AxiosInterceptor.post('kpiData/search', body),
};
